/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';

@Component({
  host: {
    class: 'card card--video',
  },
  selector: '[videoCardV2]',
  templateUrl: './video-card-v2.component.html',
  styleUrls: ['./video-card-v2.component.scss'],
})
export class VideoCardV2Component implements OnInit {
  @ViewChild('thumbnailImg')
  thumbnailImg: ElementRef;

  @Input()
  thumbnail: { source: string; link?: []; linkParams?: '' };

  @Input()
  videoDetails: { text: string; link?: string; linkParams?: '' }[] = [];

  @Input()
  showLockIcon = false;

  @Input()
  showNewVideoOverlay = false;

  @Input()
  processing = false;

  @Input()
  detailsPosition = 'bottom';

  @Input()
  index: number;

  @Input()
  placeholder = false;

  @Input()
  lineClamp = false;

  @Input()
  playingNowOverlay = false;

  @Input()
  purchaseOverlay: [];

  @Input()
  removable = false;

  @Input()
  addToLibraryOverlay = false;

  @Input()
  forbiddenTeam: boolean;

  @Input()
  askForTeam: boolean;

  @Input()
  showToggleHideStatus: boolean;

  @Input()
  hideChecked: boolean;

  @Input()
  archived = false;

  @Input()
  showBreakdownIcon = false;

  @Output()
  onSelect: EventEmitter<number> = new EventEmitter();

  @Output()
  onForbiddenTeam: EventEmitter<any> = new EventEmitter();

  @Output()
  onTeamSelection: EventEmitter<any> = new EventEmitter();

  @Output()
  onToggleHide: EventEmitter<boolean> = new EventEmitter();

  @Output()
  onRemoveClick: EventEmitter<boolean> = new EventEmitter();

  get showOverlay(): boolean {
    return this.processing;
  }

  constructor(private renderer: Renderer2) {}

  ngOnInit() {
    if (this.placeholder) {
      return;
    }
  }

  triggerSelected($event) {
    $event.preventDefault();
    this.onSelect.emit();
  }

  onForbiddenTeamClick($event) {
    this.onForbiddenTeam.emit($event);
  }

  onTeamSelectionClick($event) {
    this.onTeamSelection.emit($event);
  }

  onRemoveVideoClick($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.onRemoveClick.emit($event);
  }

  onThumbnailLoad($event, altText) {
    this.renderer.setAttribute(this.thumbnailImg.nativeElement, 'alt', altText);
  }

  onClickHideClip($event) {
    const checked = !$event.currentTarget.querySelector('input').checked;
    this.onToggleHide.emit(checked);
  }

  onUnarchiveContactClick() {
    window.location.href = `mailto:support@nextpro.com?subject=2018 game film access&body=Hi, I need access to ${this.videoDetails[1].text} Event + ${this.videoDetails[0].text} Game`;
  }
}
